// src/hooks/useAuth.js
// Custom hook for authentication state management

import { useState, useEffect, useContext, createContext } from 'react';
import { onAuthStateChanged } from 'firebase/auth';
import { auth, createUserAccount, signIn, signOut } from '../firebaseClient';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isAnonymous, setIsAnonymous] = useState(true);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, (firebaseUser) => {
      setUser(firebaseUser);
      setIsAnonymous(firebaseUser?.isAnonymous ?? true);
      setLoading(false);
      
      console.log('[useAuth] Auth state changed:', {
        userId: firebaseUser?.uid,
        isAnonymous: firebaseUser?.isAnonymous,
        email: firebaseUser?.email,
      });
    });

    return () => unsubscribe();
  }, []);

  const value = {
    user,
    loading,
    isAnonymous,
    isAuthenticated: !!user && !isAnonymous,
    signUp: createUserAccount,
    signIn,
    signOut,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
}
